import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { handleStaleResponse } from "../lib/handle_stale_response";
import { autosaveDraft, cancel as cancelAutosave } from "../components/lib/autosave_draft";

export default class extends Controller {
  static targets = ["input", "checkButton"];
  static values = {
    checkUrl: String,
    draftUrl: String,
  };

  connect() {
    this.checking = false;
    this._refreshState();
  }

  disconnect() {
    if (this.hasDraftUrlValue) cancelAutosave(this.draftUrlValue);
  }

  inputChanged() {
    this._refreshState();
    this._scheduleAutosave();
  }

  _refreshState() {
    if (!this.hasCheckButtonTarget) return;
    const someFilled = this.inputTargets.some((i) => !i.disabled && i.value.trim().length > 0);
    this.checkButtonTarget.disabled = !someFilled || this.checking;
  }

  _currentSubmitted() {
    const submitted = {};
    this.inputTargets.forEach((input) => {
      submitted[input.dataset.itemId] = input.value;
    });
    return submitted;
  }

  _scheduleAutosave() {
    if (this.checking || !this.hasDraftUrlValue) return;
    autosaveDraft({
      url: this.draftUrlValue,
      body: { submitted: this._currentSubmitted() },
    });
  }

  check(event) {
    event?.preventDefault();
    if (this.checking) return;
    if (this.checkButtonTarget.disabled) return;

    this.checking = true;
    this.checkButtonTarget.disabled = true;
    if (this.hasDraftUrlValue) cancelAutosave(this.draftUrlValue);

    const token = document.querySelector("meta[name=csrf-token]")?.content || "";
    const params = new URLSearchParams();
    this.inputTargets.forEach((input) => {
      params.append(`submitted[${input.dataset.itemId}]`, input.value);
    });

    fetch(this.checkUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token,
      },
      body: params.toString(),
    })
      .then((r) => {
        if (handleStaleResponse(this, r)) return null;
        return r.text();
      })
      .then((html) => {
        if (html) Turbo.renderStreamMessage(html);
      })
      .finally(() => {
        this.checking = false;
      });
  }
}
